import MfiCard from "../assets/DeviceImgs/card.svg";
import MfiClip from "../assets/DeviceImgs/clip.svg";
import MfiTag from "../assets/DeviceImgs/tag.png";
import blackcard_128x128 from "../assets/DeviceImgs/blackcard_128x128.png";
import breadcrumb_128x128 from "../assets/DeviceImgs/breadcrumb_128x128.png";
import dragon_hornet_128x128 from "../assets/DeviceImgs/dragon_hornet_128x128.png";
import finder_128x128 from "../assets/DeviceImgs/finder_128x128.png";
import finderV2_128x128 from "../assets/DeviceImgs/finderV2_128x128.png";
import found_128x128 from "../assets/DeviceImgs/found_128x128.png";
import honey_128x128 from "../assets/DeviceImgs/honey_128x128.png";
import stone_128x128 from "../assets/DeviceImgs/stone_128x128.png";
import unknown_128x128 from "../assets/DeviceImgs/unknown_128x128.png";

class Model {
  getModelInfo(modelNumber: number) {
    switch (modelNumber) {
      case 0:
        return {
          name: "Honey",
          img: honey_128x128,
        };
        break;
      case 1:
        return {
          name: "Honey",
          img: honey_128x128,
        };
        break;
      case 2:
        return {
          name: "Dragon",
          img: dragon_hornet_128x128,
        };
        break;
      case 3:
        return {
          name: "Hornet",
          img: unknown_128x128,
        };
        break;
      case 4:
        return {
          name: "Stone",
          img: stone_128x128,
        };
        break;
      case 5:
        return {
          name: "Finder",
          img: finder_128x128,
        };
        break;
      case 6:
        return {
          name: "Stone v2",
          img: stone_128x128,
        };
        break;
      case 7:
        return {
          name: "Nock",
          img: unknown_128x128,
        };
        break;
      case 8:
        return {
          name: "LocationMarker",
          img: unknown_128x128,
        };
        break;
      case 9:
        return {
          name: "Golf",
          img: unknown_128x128,
        };
        break;
      case 10:
        return {
          name: "Umbrella",
          img: unknown_128x128,
        };
        break;
      case 11:
        return {
          name: "BlackCard",
          img: blackcard_128x128,
        };
        break;
      case 12:
        return {
          name: "Hub Finder",
          img: unknown_128x128,
        };
        break;
      case 13:
        return {
          name: "Finder 2.0",
          img: finderV2_128x128,
        };
        break;
      case 14:
        return {
          name: "Found",
          img: found_128x128,
        };
        break;
      case 15:
        return {
          name: "Breadcrumb",
          img: breadcrumb_128x128,
        };
        break;
      case 16:
        return {
          name: "MFI Card",
          img: MfiCard,
        };
        break;
      case 17:
        return {
          name: "MFI Clip",
          img: MfiClip,
        };
        break;
      case 18:
        return {
          name: "MFI Tag",
          img: MfiTag,
        };
        break;
      case 19:
        return {
          name: "MFI Ski",
          img: unknown_128x128,
        };
        break;
      case 20:
        return {
          name: "MFI Golf",
          img: unknown_128x128,
        };
        break;
      case 21:
        return {
          name: "MFI R4KTag",
          img: unknown_128x128,
        };
        break;
      case 22:
        return {
          name: "MFI Card V2",
          img: MfiCard,
        };
        break;
      case 23:
        return {
          name: "MFI Clip V2",
          img: MfiClip,
        };
        break;
      case 24:
        return {
          name: "MFI Tag V2",
          img: MfiTag,
        };
        break;
      default:
        return {
          name: "Unknown",
          img: unknown_128x128,
        };
    }
  }
  isCellular(modelNumber: number | string) {
    const model = modelNumber.toString();
    return model === "14" || model === "15";
  }
}

const models = new Model();
export default models;
